export const XXS = '14px';
export const XS = '16px';
export const S = '18px';
export const M = '24px';
export const L = '30px';
export const XL = '69px';
export const XXL = '87px';


// WEBPACK FOOTER //
// ./src/utils/styles/theme/fontSizes.style.js